import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';
import { BoundaryDetailNotificationComponent, GISBoundaryDetailPageComponent, SharedModule } from "@app/shared";
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { BoundaryManagementModule } from '@modules/boundary-management/boundary-management.module';
import { CalendarModule } from 'primeng/calendar';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TableModule } from 'primeng/table';
import { BoundaryApproverDashboardComponent, ViewRequestComponent } from '../boundary-management';
import { AngularEditorModule } from '@kolkov/angular-editor';

const routes: Routes = [
  {
    path: 'view-request', component: ViewRequestComponent, data: { title: 'View Boundary Requests' }, canActivate: [AuthGuard]
  },
  {
    path: 'view-request/add-edit', component: GISBoundaryDetailPageComponent, data: { title: 'Boundary Request Add/Edit' }, canActivate: [AuthGuard]
  },
  {
    path: 'view-request/go-live-date', component: BoundaryDetailNotificationComponent, data: { title: 'Go Live Date' }, canActivate: [AuthGuard]
  },
  {
    path: 'gis-dashboard/add-edit', component: GISBoundaryDetailPageComponent, data: { title: 'Boundary Request Add/Edit' }, canActivate: [AuthGuard]
  },
  {
    path: 'approval-dashboard', component: BoundaryApproverDashboardComponent, data: { title: 'Boundary Approval Dashboard' }, canActivate: [AuthGuard]
  },
  {
    path: 'approval-dashboard/add-edit', component: GISBoundaryDetailPageComponent, data: { title: 'Boundary Approval Add/Edit' }, canActivate: [AuthGuard]
  },
];
@NgModule({
  declarations: [ViewRequestComponent,
    BoundaryApproverDashboardComponent],
  imports: [
    ScrollPanelModule, CalendarModule, TableModule,
    SharedModule, MatMenuModule,AngularEditorModule,
    BoundaryManagementModule,
    RouterModule.forChild(routes),
  ]
})
export class MyTasksBoundaryMgmtModule { }

